<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card tile>
        <v-toolbar flat dark color="primary" class="toolbarStyle">
          <v-toolbar-title>
            <v-icon left>mdi-format-annotation-plus</v-icon>เพิ่มข้อสอบ
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon dark @click="closeDialogExam" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span class="subtitle-1">ปิดหน้าต่าง</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="dialog_singleChoice = true"
                  >
                    <v-icon left>mdi-check-box-outline</v-icon>
                    <v-span class="textInbutton title">ตัวเลือกเดียว</v-span>
                  </div>
                  <!-- <v-card
                    class="pa-lg-5 mx-lg-auto d-flex"
                    color="white"
                    width="250px"
                    height="100%"
                    justify="center"
                    @click="dialog_singleChoice = true"
                  >
                    <v-card-text align="center" class="my-auto">
                      <v-icon left>mdi-check-box-outline</v-icon>
                      <v-span class="textInbutton title">ตัวเลือกเดียว</v-span>
                      <br/>
                      <p class="subtitle my-3">(เลือกได้เพียง 1 คำตอบ)</p>
                    </v-card-text>
                  </v-card>-->
                </v-col>

                <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="dialog_multiChoice = true"
                  >
                    <v-icon left>mdi-check-box-multiple-outline</v-icon>
                    <v-span class="textInbutton title">หลายตัวเลือก</v-span>
                  </div>
                </v-col>

                <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="dialog_matching = true"
                  >
                    <v-icon left>mdi-shuffle</v-icon>
                    <v-span class="textInbutton title">จับคู่</v-span>
                  </div>
                </v-col>

                <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="dialog_fillWord = true"
                  >
                    <v-icon left>mdi-color-helper</v-icon>
                    <v-span class="textInbutton title">เติมคำ</v-span>
                  </div>
                </v-col>

                <!-- <v-col lg="4" md="4" sm="6" xs="12">
                  <v-btn class="buttonTypeContent" @click="dialog_writing = true">
                    <v-icon left>mdi-pencil</v-icon>ข้อเขียน
                  </v-btn>
                </v-col>-->

                <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <!-- <v-btn class="buttonTypeContent" @click="dialog_examArticle = true"> -->
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="closeDialogSelect"
                    v-if="!articleId"
                  >
                    <v-icon left>mdi-format-float-left</v-icon>
                    <v-span class="textInbutton title">บทความ</v-span>
                  </div>
                </v-col>

                <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="dialog_game = true"
                  >
                    <v-icon left>extension</v-icon>
                    <v-span class="textInbutton title">เกม</v-span>
                  </div>
                </v-col>

                <!-- <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <div
                    class="lecture-type-card text-center d-flex justify-center align-center"
                    @click="dialog_descriptive = true" v-if="!articleId"
                  >
                    <v-icon left>notes</v-icon>
                    <v-span class="textInbutton title">คำบรรยาย</v-span>
                  </div>
                </v-col> -->
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <!-- Single choice dialog -->
    <single-choice-dialog
      :isOpen.sync="dialog_singleChoice"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />

    <!-- Multi choice dialog -->
    <multi-choice-dialog
      :isOpen.sync="dialog_multiChoice"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />

    <!-- Matching dialog -->
    <matching-dialog
      :isOpen.sync="dialog_matching"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />

    <!-- Fill word dialog -->
    <fill-word-dialog
      :isOpen.sync="dialog_fillWord"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />

    <!-- Exam Article dialog -->
    <exam-article-dialog
      :isOpen.sync="dialog_examArticle"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />

    <!-- Descriptive dialog -->
    <descriptive-dialog
      :isOpen.sync="dialog_descriptive"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />

    <game-exam-dialog
      :isOpen.sync="dialog_game"
      :examId.sync="examId"
      :examFormat.sync="examFormat"
      :questionId.sync="questionId"
      :reorderQuestion="reorderQuestion"
      :closeDialog="closeDialog"
      :closeExamDialog="closeExamDialog"
      :articleId="articleId"
    />
  </v-row>
</template>
<script>
import singleChoiceDialog from "@/views/course/lectures/exam/singleChoice.vue";
import multiChoiceDialog from "@/views/course/lectures/exam/multiChoice.vue";
import matchingDialog from "@/views/course/lectures/exam/matching.vue";
import fillWordDialog from "@/views/course/lectures/exam/fillInTheBlank.vue";
import examArticleDialog from "@/views/course/lectures/exam/examArticle.vue";
import descriptiveDialog from "@/views/course/lectures/exam/descriptive.vue";
import gameExamDialog from "@/views/course/lectures/exam/gameExam.vue";
export default {
  props: {
    isOpen: {
      type: Boolean,
    },
    examId: {
      type: String,
    },
    examFormat: {
      type: String,
    },
    questionId: {
      type: String,
    },
    questionType: {
      type: String,
    },
    reorderQuestion: {
      type: Function,
    },
    closeDialogExam: {
      type: Function,
    },

    articleId: {
      type: String,
    },
  },
  components: {
    singleChoiceDialog,
    multiChoiceDialog,
    matchingDialog,
    fillWordDialog,
    examArticleDialog,
    descriptiveDialog,
    gameExamDialog,
  },
  watch: {
    isOpen: async function (newValue) {
      console.log(newValue, this.questionId, "---");
      if (newValue) {
        if (this.questionId) {
          console.log(this.questionType, this.questionType === "fillgaptext");
          // this.dialog = true
          this.dialog_singleChoice =
            this.questionType === "single" ? true : false;
          this.dialog_multiChoice =
            this.questionType === "multiple" ? true : false;
          this.dialog_matching =
            this.questionType === "matchsome" ? true : false;
          this.dialog_fillWord =
            this.questionType === "fillgaptext" ? true : false;
          this.dialog_writing = this.questionType === "writing" ? true : false;
          this.dialog_examArticle =
            this.questionType === "article" ? true : false;
          this.dialog_descriptive =
            this.questionType === "descriptive" ? true : false;
        } else {
          this.dialog = true;
        }
      } else {
        this.dialog = false;
      }
    },
  },
  data() {
    return {
      maxWidth: "40%",
      dialog: false,
      dialog_singleChoice: false,
      dialog_multiChoice: false,
      dialog_matching: false,
      dialog_fillWord: false,
      dialog_writing: false,
      dialog_examArticle: false,
      notifications: false,
      dialog_descriptive: false,
      dialog_game: false,
    };
  },
  methods: {
    closeDialog() {
      console.log("this.dialog", this.dialog);
      this.dialog = false;
      // this.closeDialog()
      this.closeDialogExam();
      this.closeExamDialog();
      // this.closeDialog()
    },
    closeDialogSelect() {
      this.dialog = false;
      this.dialog_examArticle = true;
      // this.closeDialogExam()
      //  this.closeDialogExam()
    },
    closeExamDialog() {
      this.dialog_singleChoice = false;
      this.dialog_multiChoice = false;
      this.dialog_matching = false;
      this.dialog_fillWord = false;
      this.dialog_writing = false;
      this.dialog_examArticle = false;
      this.dialog_descriptive = false;
      this.dialog_game = false;
    },
  },
  beforeMount() {
    // console.log(this.questions)
    if (window.screen.width < 600) {
      this.maxWidth = "90%";
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = "90%";
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = "90%";
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = "40%";
    } else {
      this.maxWidth = "40%";
    }
  },
};
</script>
<style scoped>
.lecture-type-card {
  width: 100%;
  padding-bottom: 40%;
  padding-top: 40%;

  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lecture-type-card:hover {
  transform: scale(1.15, 1.15);
  cursor: pointer;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  /* border-radius: 50px; */
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.divExplanFile {
  justify-content: flex-end;
}
.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.labelExplan {
  text-align: justify;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
